import { render } from "./HeroiconsSolidAnnotation.vue?vue&type=template&id=6ecd6d96"
const script = {}

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidAnnotation.vue"]])

export default __exports__